/* eslint-disable */
/*!
 * @project : lego-toast
 * @version : 0.0.1
 * @author  : miss
 * @update  : 2016-11-10 10:14:35 am
 * @email   : wuweishuan@yy.com
 */

! function(t, e) { "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.LegoToast = e() : t.LegoToast = e() }(this, function() {
    return function(t) {
        function e(o) { if (n[o]) return n[o].exports; var i = n[o] = { exports: {}, id: o, loaded: !1 }; return t[o].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports }
        var n = {};
        return e.m = t, e.c = n, e.p = "", e(0)
    }([function(t, e, n) {
        function o(t) { return t && t.__esModule ? t : { "default": t } }
        var i = n(1),
            r = o(i),
            s = n(2),
            a = o(s);
        t.exports = function() {
            function t(e) {
                (0, r["default"])(this, t), "undefined" == typeof e ? (this.msg = "操作成功", this.time = 2e3, this.extraClass = "") : (this.msg = e.msg || "", this.time = e.time || 2e3, this.extraClass = e.extraClass || ""), this.init()
            }
            return (0, a["default"])(t, [{ key: "init", value: function() { this.legoToastInner = null, this.toastTimer = null, this.toastDiv = null, this.hasToastDiv = !1, this.isToastShow = !1 } }, {
                key: "createModule",
                value: function(t) {
                    this.toastDiv = document.createElement("div"), this.toastDiv.classList.add("legoToast"), this.extraClass && this.toastDiv.classList.add(this.extraClass);
                    var e = '<div class="legoToast-inner">' + this.msg + "</div>",
                        o = n(21);
                    this.toastDiv.innerHTML = "<style>" + o + "</style>" + e, document.body.appendChild(this.toastDiv), this.hasToastDiv = !0, this.legoToastInner = document.querySelector(".legoToast-inner"), "function" == typeof t && (this.legoToastInner.classList.add("legoToast-inner", "is-toastShow"), t.call(this))
                }
            }, {
                key: "open",
                value: function() {
                    var t = this;
                    this.isToastShow || (this.hasToastDiv ? (this.legoToastInner.innerHTML = this.msg, this.toastDiv.style.display = "block", this.legoToastInner.classList.add("is-toastShow"), this.legoToastInner.classList.remove("is-toastHide"), this.toastTimer = setTimeout(function() { t.close() }, this.time)) : this.createModule(function() {
                        var t = this;
                        this.toastTimer = setTimeout(function() { t.close() }, this.time)
                    }), this.isToastShow = !0)
                }
            }, {
                key: "close",
                value: function() {
                    var t = this;
                    this.toastTimer && clearTimeout(this.toastTimer), this.legoToastInner.classList.remove("is-toastShow"), this.legoToastInner.classList.add("is-toastHide"), setTimeout(function() { t.toastDiv.style.display = "none", t.isToastShow = !1 }, 450)
                }
            }, { key: "changeText", value: function(t) { this.msg = t } }, { key: "changeTime", value: function(t) { this.time = t } }]), t
        }()
    }, function(t, e) {
        "use strict";
        e.__esModule = !0, e["default"] = function(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") }
    }, function(t, e, n) {
        "use strict";

        function o(t) { return t && t.__esModule ? t : { "default": t } }
        e.__esModule = !0;
        var i = n(3),
            r = o(i);
        e["default"] = function() {
            function t(t, e) {
                for (var n = 0; n < e.length; n++) {
                    var o = e[n];
                    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), (0, r["default"])(t, o.key, o)
                }
            }
            return function(e, n, o) { return n && t(e.prototype, n), o && t(e, o), e }
        }()
    }, function(t, e, n) { t.exports = { "default": n(4), __esModule: !0 } }, function(t, e, n) {
        n(5);
        var o = n(8).Object;
        t.exports = function(t, e, n) { return o.defineProperty(t, e, n) }
    }, function(t, e, n) {
        var o = n(6);
        o(o.S + o.F * !n(16), "Object", { defineProperty: n(12).f })
    }, function(t, e, n) {
        var o = n(7),
            i = n(8),
            r = n(9),
            s = n(11),
            a = "prototype",
            u = function(t, e, n) {
                var c, f, l, h = t & u.F,
                    p = t & u.G,
                    d = t & u.S,
                    m = t & u.P,
                    y = t & u.B,
                    v = t & u.W,
                    w = p ? i : i[e] || (i[e] = {}),
                    b = w[a],
                    g = p ? o : d ? o[e] : (o[e] || {})[a];
                p && (n = e);
                for (c in n) f = !h && g && void 0 !== g[c], f && c in w || (l = f ? g[c] : n[c], w[c] = p && "function" != typeof g[c] ? n[c] : y && f ? r(l, o) : v && g[c] == l ? function(t) {
                    var e = function(e, n, o) {
                        if (this instanceof t) {
                            switch (arguments.length) {
                                case 0:
                                    return new t;
                                case 1:
                                    return new t(e);
                                case 2:
                                    return new t(e, n)
                            }
                            return new t(e, n, o)
                        }
                        return t.apply(this, arguments)
                    };
                    return e[a] = t[a], e
                }(l) : m && "function" == typeof l ? r(Function.call, l) : l, m && ((w.virtual || (w.virtual = {}))[c] = l, t & u.R && b && !b[c] && s(b, c, l)))
            };
        u.F = 1, u.G = 2, u.S = 4, u.P = 8, u.B = 16, u.W = 32, u.U = 64, u.R = 128, t.exports = u
    }, function(t, e) { var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")(); "number" == typeof __g && (__g = n) }, function(t, e) { var n = t.exports = { version: "2.4.0" }; "number" == typeof __e && (__e = n) }, function(t, e, n) {
        var o = n(10);
        t.exports = function(t, e, n) {
            if (o(t), void 0 === e) return t;
            switch (n) {
                case 1:
                    return function(n) { return t.call(e, n) };
                case 2:
                    return function(n, o) { return t.call(e, n, o) };
                case 3:
                    return function(n, o, i) { return t.call(e, n, o, i) }
            }
            return function() { return t.apply(e, arguments) }
        }
    }, function(t, e) { t.exports = function(t) { if ("function" != typeof t) throw TypeError(t + " is not a function!"); return t } }, function(t, e, n) {
        var o = n(12),
            i = n(20);
        t.exports = n(16) ? function(t, e, n) { return o.f(t, e, i(1, n)) } : function(t, e, n) { return t[e] = n, t }
    }, function(t, e, n) {
        var o = n(13),
            i = n(15),
            r = n(19),
            s = Object.defineProperty;
        e.f = n(16) ? Object.defineProperty : function(t, e, n) {
            if (o(t), e = r(e, !0), o(n), i) try { return s(t, e, n) } catch (a) {}
            if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
            return "value" in n && (t[e] = n.value), t
        }
    }, function(t, e, n) {
        var o = n(14);
        t.exports = function(t) { if (!o(t)) throw TypeError(t + " is not an object!"); return t }
    }, function(t, e) { t.exports = function(t) { return "object" == typeof t ? null !== t : "function" == typeof t } }, function(t, e, n) { t.exports = !n(16) && !n(17)(function() { return 7 != Object.defineProperty(n(18)("div"), "a", { get: function() { return 7 } }).a }) }, function(t, e, n) { t.exports = !n(17)(function() { return 7 != Object.defineProperty({}, "a", { get: function() { return 7 } }).a }) }, function(t, e) { t.exports = function(t) { try { return !!t() } catch (e) { return !0 } } }, function(t, e, n) {
        var o = n(14),
            i = n(7).document,
            r = o(i) && o(i.createElement);
        t.exports = function(t) { return r ? i.createElement(t) : {} }
    }, function(t, e, n) {
        var o = n(14);
        t.exports = function(t, e) { if (!o(t)) return t; var n, i; if (e && "function" == typeof(n = t.toString) && !o(i = n.call(t))) return i; if ("function" == typeof(n = t.valueOf) && !o(i = n.call(t))) return i; if (!e && "function" == typeof(n = t.toString) && !o(i = n.call(t))) return i; throw TypeError("Can't convert object to primitive value") }
    }, function(t, e) { t.exports = function(t, e) { return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e } } }, function(t, e, n) { var o = n(22); "string" == typeof o ? t.exports = o : t.exports = o.toString() }, function(t, e, n) { e = t.exports = n(23)(), e.push([t.id, ".legoToast{position:fixed;left:50%;top:50%;z-index:999;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.legoToast-inner{width:auto;background:rgba(0,0,0,.8);border-radius:20px;color:#fff;padding:0 16px;height:32px;line-height:32px;font-size:14px;opacity:0}.legoToast-inner.is-toastShow{-webkit-animation-name:toastshow;animation-name:toastshow;-webkit-animation-timing-function:cubic-bezier(0,.33,.2,1);animation-timing-function:cubic-bezier(0,.33,.2,1);-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.legoToast-inner.is-toastHide,.legoToast-inner.is-toastShow{-webkit-animation-delay:0s;animation-delay:0s;-webkit-animation-duration:.4s;animation-duration:.4s}.legoToast-inner.is-toastHide{-webkit-animation-name:toasthide;animation-name:toasthide;-webkit-animation-timing-function:cubic-bezier(0,.33,.2,1);animation-timing-function:cubic-bezier(0,.33,.2,1);-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}@-webkit-keyframes toastshow{0%{opacity:0;-webkit-transform:scale(1.185);transform:scale(1.185)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes toastshow{0%{opacity:0;-webkit-transform:scale(1.185);transform:scale(1.185)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes toasthide{0%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}to{opacity:0;-webkit-transform:scale(.815);transform:scale(.815)}}@keyframes toasthide{0%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}to{opacity:0;-webkit-transform:scale(.815);transform:scale(.815)}}", ""]) }, function(t, e) {
        t.exports = function() {
            var t = [];
            return t.toString = function() {
                for (var t = [], e = 0; e < this.length; e++) {
                    var n = this[e];
                    n[2] ? t.push("@media " + n[2] + "{" + n[1] + "}") : t.push(n[1])
                }
                return t.join("")
            }, t.i = function(e, n) {
                "string" == typeof e && (e = [
                    [null, e, ""]
                ]);
                for (var o = {}, i = 0; i < this.length; i++) { var r = this[i][0]; "number" == typeof r && (o[r] = !0) }
                for (i = 0; i < e.length; i++) { var s = e[i]; "number" == typeof s[0] && o[s[0]] || (n && !s[2] ? s[2] = n : n && (s[2] = "(" + s[2] + ") and (" + n + ")"), t.push(s)) }
            }, t
        }
    }])
});


// WEBPACK FOOTER //
// ./src/Footer/util/legoToast.min.js